var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingQuest } from "../../../../balancingSelectors/selectBalancingQuests";
import { QuestStateType } from "../../../../utils/network/generated/protoTypes";
import { actionModalClose, actionModalTabSelect } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
var MasterViewAdventureQuestsDOM = /** @class */ (function (_super) {
    __extends(MasterViewAdventureQuestsDOM, _super);
    function MasterViewAdventureQuestsDOM(props) {
        return _super.call(this, props) || this;
    }
    MasterViewAdventureQuestsDOM.prototype.render = function () {
        return (React.createElement("div", { className: "quest-container" },
            React.createElement("h2", null, "Adventure Quest Not Implemented")));
    };
    return MasterViewAdventureQuestsDOM;
}(React.Component));
var mapState = function (state) {
    var completedQuestIds = [];
    if (state.questInfo.quest != undefined) {
        state.questInfo.quest.forEach(function (value) {
            var availableQuest = selectBalancingQuest(value.questId);
            if (availableQuest == undefined) {
                return;
            }
            if (value.state === QuestStateType.COMPLETE) {
                completedQuestIds.push(availableQuest.id);
            }
        });
    }
    return {
        completedQuestIds: completedQuestIds,
        selectedQuest: state.questInfo.selectedQuest,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.Quests)); },
    onTabSelect: function (tabId) { return actionModalTabSelect(tabId); },
}); };
export var MasterViewAdventureQuests = connect(mapState, mapDispatch)(MasterViewAdventureQuestsDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/MasterViewAdventureQuests.tsx
// module id = 2657
// module chunks = 3